import { createSlice } from "@reduxjs/toolkit";

import nativeStorage from "utils/localStorage";

const _localStorage =
  typeof navigator != "undefined" && navigator.product == "ReactNative"
    ? nativeStorage
    : localStorage;

const initialState = {
  token: _localStorage.getItem("token"),
  status: "idle",
  primaryCalendarId: _localStorage.getItem("primaryCalendarId"),
  needsReset: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenSet(state, action) {
      _localStorage.setItem("token", action.payload);
      state.token = action.payload;
    },
    setPrimaryCalendarId(state, action) {
      _localStorage.setItem("primaryCalendarId", action.payload);
      state.primaryCalendarId = action.payload;
    },
    setNeedsReset(state, action) {
      state.needsReset = action.payload;
    },
  },
});

export const {
  tokenSet,
  setPrimaryCalendarId,
  setNeedsReset,
} = authSlice.actions;

export default authSlice.reducer;
